import { render, staticRenderFns } from "./ShowCircuitoNotasPage.vue?vue&type=template&id=4f7ea1b8"
import script from "./ShowCircuitoNotasPage.vue?vue&type=script&lang=js"
export * from "./ShowCircuitoNotasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports